const tableTitleManagementBackups = {
  title: 'Backups Management (App)',
  placeholder: 'Search',
};

export default tableTitleManagementBackups;
